import {
    TextHelper,
    SmallTextHelper,
    UrlHelper,
    ArrayHelper,
    EmbedHelper
} from '../../PrismicHelpers';

export const singleMediaSlice = (data) => {
    // Always take the slice_type and return it with data, helper will know what to display/render
    const dataType = data.slice_type;
    // Non repetable data inside slice
    const sliceFixedData = data.primary;
    // Repetable data (example: buttons)
    //const sliceRepetableData = data.items;

    // Data to send to the array of slices (always type and data if needed)
    let dataToSend = {
        type: dataType,
        title: TextHelper(sliceFixedData.title),
        margins: SmallTextHelper(sliceFixedData.margins),
        description: ArrayHelper(sliceFixedData.description),
        button_title: TextHelper(sliceFixedData.button_title),
        button_url: UrlHelper(sliceFixedData.button_url),
        image: UrlHelper(sliceFixedData.image),
        image_alternative: TextHelper(sliceFixedData.image_alternative),
        media_position: SmallTextHelper(sliceFixedData.media_position),
        text_align: SmallTextHelper(sliceFixedData.text_align),
        media_type: SmallTextHelper(sliceFixedData.media_type),
        youtube: EmbedHelper(sliceFixedData.youtube),
        wistia: TextHelper(sliceFixedData.wistia)
    };
    return dataToSend;
}



// WEBPACK FOOTER //
// src/client/helpers/prismicHelpers/prismic-slice-helpers/single-slice-helpers/singleMediaSlice.js